import type { HTMLAttributes, ReactNode } from 'react';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Adds inner padding. Turn off to lay out edge-to-edge content yourself. */
  padded?: boolean;
  /** Adds hover lift and pointer cursor for clickable cards. */
  interactive?: boolean;
}

/** A rounded surface panel with a soft shadow. */
export function Card({ padded = true, interactive = false, className, children, ...rest }: CardProps) {
  const classes = [
    'pt-card',
    padded ? 'pt-card--pad' : '',
    interactive ? 'pt-card--interactive' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}

export interface CardHeaderProps {
  title: ReactNode;
  /** Optional element rendered on the right, e.g. a menu or badge. */
  action?: ReactNode;
}

export function CardHeader({ title, action }: CardHeaderProps) {
  return (
    <div className="pt-card__header">
      <div className="pt-card__title">{title}</div>
      {action}
    </div>
  );
}
